<template>
  <div class="card kpi-detail mb-4 h-100">
    <div class="card-header fw-bold text-truncate">
      <div class="row">
        <div class="col-12">
          {{ kpi.name }} [{{kpi.unit}}]
          <span class="d-flex float-end">
            <div class="fs-08 fw-normal mt-1 me-3">
              <a :href="createLink('kpi', kpi.id)" class="text-decoration-none fs-08" target="_blank">KPI-Definition </a>
            </div>
            <svg @click=favoriteKPI(kpi.id) role="button" class="btn-favorite bi me-3" fill="currentColor">
              <use v-if="favoriteKPIs?.includes(kpi.id)" xlink:href="@/assets/icons/icons.svg#star-fill"/>
              <use v-else xlink:href="@/assets/icons/icons.svg#star"/>
            </svg>
            <span @click=deselectKPI(kpi.id) role="button" class="btn-close small opacity-100"></span>
          </span>
        </div>
      </div>
    </div>
    <div class="card-body pt-2 pb-0">
      <div class="row justify-content-center mb-4">
        <div class="col-3">
          <label for="filterTimeDim" class="form-label small mb-0">{{ $t("views.kpi.periods.timeDim") }}:</label>
          <select @change="updateFilterFromTo()" v-model="filterTimeDim" id="filterTimeDim" class="form-select form-select-sm">
            <option v-if="kpi.timeDimInput === 'M'" value="M">{{ $t("general.month") }}</option>
            <option v-if="kpi.timeDimInput !== 'Y'" value="Q">{{ $t("general.quarter") }}</option>
            <option value="Y">{{ $t("general.year") }}</option>
          </select>
        </div>
        <div class="col-3">
          <label for="filterFrom" class="form-label small mb-0">{{ $t("views.kpi.periods.from") }}:</label>
          <select v-model="filterFrom" id="filterFrom" class="form-select form-select-sm">
            <option v-for="option in filterOptions" :key="'filterFrom' + option" :value="option">{{ formatPeriod(option) }}</option>
          </select>
        </div>
        <div class="col-3">
          <label for="filterTo" class="form-label small mb-0">{{ $t("views.kpi.periods.to") }}:</label>
          <select v-model="filterTo" id="filterTo" class="form-select form-select-sm">
            <option v-for="option in filterOptions" :key="'filterTo' + option" :value="option">{{ formatPeriod(option) }}</option>
          </select>
        </div>
        <div class="col-3">
          <label class="form-label small mb-0"> {{ $t("views.kpi.periods.available") }}:</label>
          <div class="form-control form-control-sm bg-light">
            <span v-if="filteredPeriodsReverse?.length > 0"> {{ Math.min(...filterOptions.map(p => Number(p.slice(0, 4)))) }} - {{ Math.max(...filterOptions.map(p => Number(p.slice(0, 4)))) }} </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <KPIPeriodMultiChart :key="'kpiPeriods' + kpiKeyInt + kpi.id" :chartId="'chartMulti' + kpi.id" :periods="filteredPeriods" class="kpi-chart"></KPIPeriodMultiChart>
        </div>
      </div>
      <div class="row">
        <div v-if="filteredPeriodsReverse?.length>0">
          <div class="col">
            <div class="table-kpi-data mt-3">
              <table class="table table-bordered text-center table-sm table-striped fs-08 mb-0">
                <thead class="table-primary" >
                  <tr>
                    <th scope="col">{{ $t("views.kpi.periods.period") }}</th>
                    <th scope="col">{{ $t("views.kpi.edit.actual") }}</th>
                    <th scope="col">{{ $t("views.kpi.edit.forecast") }}</th>
                    <th scope="col">{{ $t("views.kpi.edit.plan") }}</th>
                    <th scope="col">{{ $t("views.kpi.edit.objective") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="period in filteredPeriodsReverse" :key="kpi.id + period" class="text-end">
                    <th scope="row" class="fw-normal text-center">{{ formatPeriod(period.period) }}</th>
                    <td>{{ isValidNumber(unFormatNumber(period.actual)) ? period.actual : '-' }}</td>
                    <td>{{ isValidNumber(unFormatNumber(period.forecast)) ? period.forecast : '-' }}</td>
                    <td>{{ isValidNumber(unFormatNumber(period.plan)) ? period.plan : '-' }}</td>
                    <td>{{ isValidNumber(unFormatNumber(period.objective)) ? period.objective : '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-else class="mt-4 text-center bg-secondary text-white">{{ $t("views.kpi.detail.noData") }} </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as formatUtils from '../../composables/formatUtils'
import KPIPeriodMultiChart from '../charts/KPIPeriodMulti.vue'

export default {
  name: 'KPIPeriods',
  props: ['kpi'],
  data () {
    return {
      kpiKeyInt: 0,
      filterTimeDim: this.kpi.timeDimDisplay,
      filterFrom: '',
      filterTo: '',
      filterOptions: ''
    }
  },
  components: {
    KPIPeriodMultiChart
  },
  computed: {
    sysParms () {
      return this.$store.state.sysParms
    },
    favoriteKPIs () {
      return this.$store.state.user?.settings?.favorites?.kpis
    },
    filteredPeriods () {
      return this.kpi.records.filter(record => {
        return record.period.toString().length === this.filterFrom.toString().length &&
               record.period >= this.filterFrom && record.period <= this.filterTo
      })
    },
    filteredPeriodsReverse () {
      return this.kpi.records.filter(record => {
        return record.period.toString().length === this.filterFrom.toString().length &&
               record.period >= this.filterFrom && record.period <= this.filterTo
      }).reverse()
    }
  },
  methods: {
    updateFilterFromTo () {
      let filterStartYear = ''
      let filterEndYear = ''

      /* Alte Logik (Filterübernahme von ParentForm) NICHT LÖSCHEN, WEIL WIR DAS EVTL. NOCH BRAUCHEN
      if (this.$parent.filterValidFrom && this.$parent.filterValidTo) {
        filterStartYear = this.$parent.filterValidFrom.substr(0, 4)
        filterEndYear = this.$parent.filterValidTo.substr(0, 4)
      } else {
      }
      */

      // Verfügbares Min/Max-Jahr aus FilterOptions bestimmen
      const optionYears = this.filterOptions.map(p => Number(p.slice(0, 4)))
      const minDataYear = Math.min(...optionYears)
      const maxDataYear = Math.max(...optionYears)

      // Aufsetzpunkt ermitteln
      let currentYear = new Date().getFullYear()
      if (maxDataYear < currentYear) currentYear = maxDataYear // Nur Vergangenheitsdaten
      if (minDataYear > currentYear) currentYear = minDataYear // nur Zukunftsdaten

      // Filterwerte Start/Ende setzen (verfügbares Min/Max-Jahr oder Sysparm-Past/FutureYears)
      if (this.filterTimeDim === 'M') {
        filterStartYear = String(Math.max(minDataYear, currentYear - +(this.sysParms.kpiChartMonthPast)))
        filterEndYear = String(Math.min(maxDataYear, currentYear + +(this.sysParms.kpiChartMonthFuture)))
        this.filterFrom = filterStartYear + '01'
        this.filterTo = filterEndYear + '12'
      } else if (this.filterTimeDim === 'Q') {
        filterStartYear = String(Math.max(minDataYear, currentYear - +(this.sysParms.kpiChartQuarterPast)))
        filterEndYear = String(Math.min(maxDataYear, currentYear + +(this.sysParms.kpiChartQuarterFuture)))
        this.filterFrom = filterStartYear + '1'
        this.filterTo = filterEndYear + '4'
      } else {
        filterStartYear = String(Math.max(minDataYear, currentYear - +(this.sysParms.kpiChartYearPast)))
        filterEndYear = String(Math.min(maxDataYear, currentYear + +(this.sysParms.kpiChartYearFuture)))
        this.filterFrom = filterStartYear
        this.filterTo = filterEndYear
      }

      this.kpiKeyInt++
    },
    updateFilterOptions () {
      // Verfügbare Jahre aus den KPI-Records extrahieren
      const years = (this.kpi.records ?? [])
        .map(r => Number(r.period.slice(0, 4)))

      // Kleinstes und größtes Jahr bestimmen (Fallback: 0 / aktuelles Jahr)
      const minYear = years.length ? Math.min(...years) : 0 // alternativ new Date().getFullYear()
      const maxYear = years.length ? Math.max(...years) : 0 // alternativ new Date().getFullYear()

      // Zeitinkremente abhängig von der Zeitdimension
      const unitsByDim = {
        M: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        Q: ['1', '2', '3', '4'],
        Y: ['']
      }
      const periodsFilterUnits = unitsByDim[this.filterTimeDim] ?? ['']

      // Filteroptionen mit allen Perioden zwischen kleinstem und größtem Jahr generieren
      const filterOptions = []
      for (let year = minYear; year <= maxYear; year++) {
        periodsFilterUnits.forEach(unit => filterOptions.push(year.toString() + unit))
      }

      this.filterOptions = filterOptions
      this.kpiKeyInt++
    },
    async favoriteKPI (kpiId) {
      this.$store.commit('SET_LOADING_STATUS', true)
      await this.$store.dispatch('favoriteObject', { isList: true, objectKey: 'kpis', objectValue: kpiId })
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    deselectKPI (kpiId) {
      this.$store.commit('SET_LOADING_STATUS', true)
      this.$store.dispatch('deleteSelectedKPI', { kpiId })
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    createLink (type, uuid) {
      let url = ''
      if (type === 'objective') url = '/objectives/manage/objectives?id=' + uuid
      if (type === 'project') url = '/projects/manage/projects?id=' + uuid
      if (type === 'kpi') url = '/monitoring/manage/kpis?id=' + uuid
      if (type === 'strategy') url = '/strategies/manage/strategies?id=' + uuid
      return url
    },
    formatPeriod (period) {
      return formatUtils.formatPeriod(period)
    },
    unFormatNumber (number) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.unFormatNumber(userLocale, number)
    },
    isValidNumber (value) {
      return formatUtils.isValidNumber(value)
    }
  },
  watch: {
    kpi: {
      immediate: true,
      handler (newKpi) {
        if (newKpi?.timeDimDisplay) {
          this.filterTimeDim = newKpi.timeDimDisplay
          this.updateFilterOptions()
          this.updateFilterFromTo()
        }
      }
    },
    filterTimeDim () {
      this.updateFilterOptions()
      this.updateFilterFromTo()
    },
    filterFrom () {
      this.kpiKeyInt++
    },
    filterTo () {
      this.kpiKeyInt++
    }
  },
  created () {
    this.updateFilterOptions()
    this.updateFilterFromTo()
  }
}
</script>

<style scoped>
.kpi-chart {
  max-height: 150px;
}
.table-kpi-data {
  max-height: 200px;
  overflow-y: scroll;
}
.table-kpi-data table {
  table-layout: fixed;
}
.btn-favorite, .btn-close {
  width: 19px;
  height: 19px;
  margin-top: 3px;
}
.btn-close {
  font-size: 15px;
  padding: 1px 0 0 0;
}
</style>
